<template>
  <div style="height: 100vh;width: 100vw;">
    <!-- 页头 -->
    <nav-header2 style="position: absolute;z-index: 999;"></nav-header2>
    <div style="height: 60px;"></div>
    <div style="display: flex;height: calc(100% - 60px);width: 100%;">
      <!-- 侧边栏 -->
      <side-bar></side-bar>
      <div style="flex: 1;padding: 10px;background-color: #e4e7ed;display: flex;">
        <div class="content-box" style="width: 0px;">
          <div class="table-list">
            <!-- <div class="tab">
              <span style="color: #999999;">产品管理</span>
            </div> -->
            <div class="title-box">
              <!-- 标题 -->
              <div class="title">产品列表</div>
              <!-- 按钮 -->
              <div class="btn-box">
                <!-- <el-button>添加管理员</el-button> -->
                <!-- <div
                  class="btn"
                  @click="addadmin()"
                >添加</div> -->
                <!-- <div
                  class="btn"
                  @click="deleteallshow()"
                >批量删除</div>
                <div class="btn">排序</div>
                <div
                  class="btn"
                  @click="exportExcel()"
                >
                  <img
                    class="exportimg"
                    src="../assets/img/export.png"
                  >
                  导出
                </div> -->
              </div>
            </div>

            <!-- 下拉选择框 -->
            <div class="select-box">
              <!-- <div class="select">
                <el-date-picker
                  @change="changestartdate()"
                  v-model="startdate"
                  type="date"
                  placeholder="日期（起）"
                >
                </el-date-picker>
              </div>
              <div class="select">
                <el-date-picker
                  @change="changestartdate()"
                  v-model="enddate"
                  type="date"
                  placeholder="日期（止）"
                >
                </el-date-picker>
              </div> -->
              <div class="select">
                <el-input clearable v-model="searchphone" placeholder="请输入内容"></el-input>
              </div>
              <div class="search" @click="handleSearch()">查询</div>
              <div style="margin-left: auto;display: flex;">
                <div class="btn search" @click="addadmin()">新增产品</div>
                <div class="btn search" @click="handleSearch()">刷新</div>
              </div>
            </div>
            <div class="listsbox hqsjkdata">
              <div>
                <div class="networkListtitle">
                  <div class="useremail titlebox">产品名称</div>
                  <div class="inputcheck">
                    <!-- <div
                    class="titlebox"
                    style="width: 32px;"
                  >
                    <el-checkbox
                      v-model="checkAll"
                      @change="checkall()"
                    ></el-checkbox>
                  </div> -->
                    <div class="username titlebox">
                      产品型号</div>
                  </div>
                  <!-- <div class="usermobile titlebox">电话</div> -->
                  <div class="userfirm titlebox">产品图片</div>
                  <div class="userdate titlebox">创建时间</div>
                  <!-- <div class="networknum titlebox">是否启用</div> -->
                  <!-- <div class="networknum titlebox">网络数量</div>
                <div class="equipmentnum titlebox">设备数量</div> -->
                  <div class="networkoperate titlebox">
                    <div style="width: 240px; ">操作</div>
                  </div>
                </div>
              </div>
              <div>
                <div class="userList" v-for="i in userList" :key="i.id">
                  <div class="useremail">{{ i.adminProductName }}</div>
                  <div class="inputcheck">
                    <!-- <div style="width: 32px;">
                    <el-checkbox v-model="i.checked"></el-checkbox>
                  </div> -->
                    <div class="username">{{ i.adminProductModel }}</div>
                  </div>
                  <!-- <div class="usermobile">{{ i.mobile }}</div> -->
                  <div class="userfirm">
                    <!-- <img
                    :src="picUrl+i.adminProductPIC"
                    width="25"
                    height="25"
                  /> -->
                    <el-image style="width: 25px; height: 25px" :src="serviceurl + i.adminProductPIC"
                      @click="hqtpfd(serviceurl + i.adminProductPIC)" :preview-src-list="srcList">
                    </el-image>
                  </div>
                  <!-- <div
                  class="userfirm"
                  v-if="i.issuper == 'manager'"
                >{{超级管理员}}</div>
                <div
                  class="userfirm"
                  v-if="i.issuper == 'kaifa'"
                >开发者</div> -->
                  <div class="userdate">{{ i.adminProductDate }}</div>
                  <!-- <div
                  class="networknum"
                  v-if="i.status == 0"
                ><el-button
                    type="success"
                    size="mini"
                    plain
                  >已启用</el-button></div>
                <div
                  class="networknum"
                  v-else
                ><el-button
                    type="info"
                    size="mini"
                    plain
                  >已停用</el-button></div> -->
                  <!-- <div class="networknum">{{ i.networkslen }}/{{ i.networknum }}</div>
                <div class="equipmentnum">{{ i.Memberslen }}/{{ i.equipmentnum }}</div> -->
                  <div class="networkoperate">
                    <div class="userkbtn" style="color: #f5222d" @click="shownotice(i.id)">删除</div>
                    <div class="userkbtn" @click="changenumber(i)">编辑</div>
                  </div>

                  <!-- 删除用户 -->
                  <div v-if="i.id == delid" class="notice">
                    <div class="overlay"></div>
                    <div class="deleteallbox">
                      <div style="padding: 20px;">提示</div>
                      <div style="text-align: center;padding: 20px 30px">确定删除此产品？删除后产品信息将会被彻底清除！
                      </div>
                      <div style="margin-top: 16px;">
                        <div style="display: flex;justify-content: flex-end;">
                          <div @click="shownotice(i)" class="addbtn" style="margin-left: 0px;">取消
                          </div>
                          <div @click="userDelete(i.id)" class="addbtn"
                            style="color: white;background-color: #1677ff;margin-left: 20px;margin-right: 15px;margin-bottom: 20px;">
                            确定</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 设定数量 -->
            <div v-if="shownumber" class="notice">
              <div class="overlay"></div>
              <div class="addbox">
                <div class="addtitle">设置数量</div>
                <div class="addtable">
                  <el-form :rules="rules" ref="form" :model="form" label-width="80px">
                    <el-form-item label="网络数量" prop="name">
                      <el-input placeholder="请输入网络数量" v-model="form.networknum"></el-input>
                    </el-form-item>
                    <el-form-item label="设备数量">
                      <el-input placeholder="请输入设备数量" v-model="form.equipmentnum"></el-input>
                    </el-form-item>
                  </el-form>
                  <div style="display: flex;justify-content: end;">
                    <div class="addbtn" @click="changenumber()">取消</div>
                    <div class="addbtn" @click="enternumber(i)" style="background-color: #012f55;color: white;">确认
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 删除所有展示 -->
            <div v-if="alldelete">
              <div class="overlay"></div>
              <div class="deleteallbox">
                <div style="padding: 20px;">提示</div>
                <div style="text-align: center;padding: 20px 30px">确定删除所选产品？删除后产品信息将会被彻底清除！</div>
                <div style="margin-top: 16px;">
                  <div style="display: flex;justify-content: flex-end;">
                    <div @click="deleteallcancel()" class="addbtn" style="margin-left: 0px;">取消
                    </div>
                    <div @click="deleteallenter()" class="addbtn"
                      style="color: white;background-color: #012f55;margin-left: 20px;margin-right: 15px;margin-bottom: 20px;">
                      确定</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="position: absolute;width: 98%;bottom: 0px;background: #fefefe;">
            <!-- 分页 -->
            <!-- <div class="currentpage">
              <button
                class="pagination"
                @click="goToPreviousPage()"
                :disabled="currentPage === 1"
                :class="{ 'pagination-hover': currentPage !== 1 }"
              >上一页</button>
              <span
                v-for="page in pages"
                :key="page"
              >
                <button
                  @click="goToPage(page)"
                  class="pagination2"
                  :class="{ 'pagination-active': page === currentPage }"
                >{{
                                    page }}</button>
              </span>
              <button
                class="pagination"
                @click="goToNextPage()"
                :class="{ 'pagination-hover': currentPage !== totalPages }"
                :disabled="currentPage === totalPages"
              >下一页</button>
              <span style="margin-left:10px;">总数：{{fuserList.length}}</span>
            </div> -->
            <el-pagination @size-change="handleSizeChange" style="margin-bottom: 10px;float:right"
              @current-change="handleCurrentChange" :current-page="current" :pager-count="5"
              :page-sizes="[10, 20, 30, 40]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
              :total="fuserList">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增 -->
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="zdyxzcpzk"
      width="692px" :before-close="handleClose">
      <el-form :rules="rules" ref="dialogformdata" :model="formdata">
        <el-form-item label="产品图片" class="zdycpt" prop="name">
          <el-upload action="#" :http-request="customUpload" class="avatar-uploader" :on-change="handleChange">
            <img v-if="dialogImageUrl" width="100" height="100" :src="dialogImageUrl" class="avatar">
            <dl v-else style="margin: 0;width: 98px;padding-top: 15px;">
              <!-- <p
                style="font-size: 12px;margin: 0px;height: 20px;line-height: 20px;background: #342d2d;color: #fff;text-align: left;margin-bottom: 6px;">
                * 商品主图</p> -->
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <title style="color: #333;display: block;font-size: 12px;line-height: 25px;">添加产品图片</title>
            </dl>
          </el-upload>
          <!-- <el-upload class="avatar-uploader" list-type="picture-card"
            :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-change="handleChange">
            <img v-if="dialogImageUrl" width="100" height="100" :src="dialogImageUrl" class="avatar">
            <dl v-else style="margin: 0;width: 98px;padding-top: 15px;">
              <p
                style="font-size: 12px;margin: 0px;height: 20px;line-height: 20px;background: #342d2d;color: #fff;text-align: left;margin-bottom: 6px;">
                * 商品主图</p>
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <title style="color: #333;display: block;font-size: 12px;line-height: 25px;">添加产品图片</title>
            </dl>
          </el-upload> -->
          <span style="color: #333 !important;
    font-size: 12px !important;
    float: left;
    line-height: normal;
    margin-left: 115px;
    margin-top: -16px;">(请上传800*800像素的产品图片)</span>
        </el-form-item>
        <el-form-item label="产品名称" prop="namea">
          <el-input clearable v-model="formdata.namea" size="small" autocomplete="off" placeholder="请输入产品名称"></el-input>
        </el-form-item>
        <el-form-item label="产品型号" prop="name">
          <el-input clearable v-model="formdata.name" size="small" placeholder="请输入产品型号" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="产品资料链接">
          <el-input clearable v-model="formdata.nameb" size="small" placeholder="请输入产品资料链接"
            autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="固件一">
          <el-col :span="5" style="margin-right:15px">
            <el-input clearable v-model="guja.version" size="small" placeholder="请输入版本号"></el-input>
          </el-col>
          <el-col :span="3">
            <el-upload action="#" :auto-upload="false" :on-change="handleChangeg">
              <el-button size="small" type="text">点击上传</el-button>
            </el-upload>
            <el-progress v-if="percentagegshow" :percentage="percentageg"></el-progress>
          </el-col>
          <el-col :span="13" style="font-size: 12px;">
            <a>{{ guja.name }}</a>
          </el-col>
          <!-- <el-col :span="5">
            <a>{{guja.date}}</a>
          </el-col> -->
        </el-form-item>
        <el-form-item label="固件二">
          <el-col :span="5" style="margin-right:15px">
            <el-input clearable v-model="gujb.version" size="small" placeholder="请输入版本号"></el-input>
          </el-col>
          <el-col :span="3">
            <el-upload action="#" :auto-upload="false" :on-change="handleChangeh">
              <el-button size="small" type="text">点击上传</el-button>
            </el-upload>
            <el-progress v-if="percentagehshow" :percentage="percentageh"></el-progress>
          </el-col>
          <el-col :span="13" style="font-size: 12px;">
            <a>{{ gujb.name }}</a>
          </el-col>
          <!-- <el-col :span="5">
            <a>{{gujb.date}}</a>
          </el-col> -->
        </el-form-item>
        <el-form-item label="固件三">
          <el-col :span="5" style="margin-right:15px">
            <el-input clearable v-model="gujc.version" size="small" placeholder="请输入版本号"></el-input>
          </el-col>
          <el-col :span="3">
            <el-upload action="#" :auto-upload="false" :on-change="handleChangej">
              <el-button size="small" type="text">点击上传</el-button>
            </el-upload>
            <el-progress v-if="percentagejshow" :percentage="percentagej"></el-progress>
          </el-col>
          <el-col :span="13" style="font-size: 12px;">
            <a>{{ gujc.name }}</a>
          </el-col>
          <!-- <el-col :span="5">
            <a>{{gujc.date}}</a>
          </el-col> -->
        </el-form-item>
        <el-form-item label="产品功能" class="zdybkys">
          <el-checkbox v-model="formdata.namec">组网管理</el-checkbox>
          <el-checkbox v-model="formdata.named">数据中心</el-checkbox>
          <el-checkbox v-model="formdata.namev">VPN</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" style="padding:8px 35px;">取 消</el-button>
        <el-button type="primary" style="padding:8px 35px;background:#1677ff" @click="submitData">确认</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisiblr" :close-on-click-modal="false" class="zdyxzcpzk"
      width="692px" :before-close="handleClose1">
      <el-form :rules="rules" ref="dialogformdata1" :model="formdata" :inline="false">
        <el-form-item label="产品图片" prop="name" class="zdycpt">
          <el-upload action="#" class="avatar-uploader" :on-change="handleChange">
            <img v-if="dialogImageUrl" width="100" height="100" :src="dialogImageUrl" class="avatar">
            <dl v-else style="margin: 0;width: 98px;">
              <p
                style="font-size: 12px;margin: 0px;height: 20px;line-height: 20px;background: #342d2d;color: #fff;text-align: left;margin-bottom: 6px;">
                * 商品主图</p>
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <title style="color: #333;display: block;font-size: 12px;line-height: 25px;">添加产品图片</title>
            </dl>
          </el-upload>
          <span style="color: #333 !important;
    font-size: 12px !important;
    float: left;
    line-height: normal;
    margin-left: 115px;
    margin-top: -16px;">(请上传800*800像素的产品图片)</span>
        </el-form-item>
        <el-form-item label="产品名称" prop="namea">
          <el-input clearable v-model="formdata.namea" size="small" autocomplete="off" placeholder="请输入产品名称"></el-input>
        </el-form-item>
        <el-form-item label="产品型号" prop="name">
          <el-input clearable v-model="formdata.name" size="small" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="产品资料链接">
          <el-input clearable v-model="formdata.nameb" size="small" placeholder="请输入产品资料链接"
            autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="固件一">
          <el-col :span="5">
            <a><el-input clearable v-model="guja.version" style="width: 108px;" size="small"
                placeholder="请输入版本号"></el-input></a>
          </el-col>
          <el-col :span="6" style="margin-right:15px">
            <a>{{ guja.date }}</a>
          </el-col>
          <el-col :span="5" style="overflow: hidden;height: 40px;font-size: 12px;">
            <a :title="guja.name">{{ guja.name }}</a>
          </el-col>
          <el-col :span="2" style="float: right;width: 120px;">
            <el-upload action="#" :auto-upload="false" :on-change="handleChangeg">
              <el-button size="small" type="text">点击上传</el-button>
            </el-upload>
            <el-progress v-if="percentagegshow" :percentage="percentageg"></el-progress>
          </el-col>
        </el-form-item>
        <el-form-item label="固件二">
          <el-col :span="5">
            <a><el-input clearable v-model="gujb.version" style="width: 108px;" size="small"
                placeholder="请输入版本号"></el-input></a>
          </el-col>
          <el-col :span="6" style="margin-right:15px">
            <a>{{ gujb.date }}</a>
          </el-col>
          <el-col :span="5" style="overflow: hidden;height: 40px;font-size: 12px;">
            <a :title="gujb.name">{{ gujb.name }}</a>
          </el-col>
          <el-col :span="2" style="float: right;width: 120px;">
            <el-upload action="#" :auto-upload="false" :on-change="handleChangeh">
              <el-button size="small" type="text">点击上传</el-button>
            </el-upload>
            <el-progress v-if="percentagehshow" :percentage="percentageh"></el-progress>
          </el-col>
        </el-form-item>
        <el-form-item label="固件三">
          <el-col :span="5">
            <a><el-input clearable v-model="gujc.version" style="width: 108px;" size="small"
                placeholder="请输入版本号"></el-input></a>
          </el-col>
          <el-col :span="6" style="margin-right:15px">
            <a>{{ gujc.date }}</a>
          </el-col>
          <el-col :span="5" style="overflow: hidden;height: 40px;font-size: 12px;">
            <a :title="gujc.name">{{ gujc.name }}</a>
          </el-col>
          <el-col :span="2" style="float: right;width: 120px;">
            <el-upload action="#" :auto-upload="false" :on-change="handleChangej">
              <el-button size="small" type="text">点击上传</el-button>
            </el-upload>
            <el-progress v-if="percentagejshow" :percentage="percentagej"></el-progress>
          </el-col>
        </el-form-item>
        <el-form-item label="产品功能" class="zdybkys">
          <el-checkbox v-model="formdata.namec">组网管理</el-checkbox>
          <el-checkbox v-model="formdata.named">数据中心</el-checkbox>
          <el-checkbox v-model="formdata.namev">VPN</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose1" style="padding:8px 35px;">取 消</el-button>
        <el-button type="primary" style="padding:8px 35px;background:#1677ff" @click="submitData">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" width="20%">
      <el-form :rules="rules" ref="formdata" :model="formdata" :inline="false">
        <el-form-item label="固件一" prop="name" v-if="gujy == '1'" :label-width="formLabelWidth">
          <el-col :span="11">
            <el-upload action="#" :auto-upload="false" :limit="1" :on-change="handleChangeg">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-col>
          <el-col :span="11" style="margin-right:15px">
            <el-input clearable v-model="guja.version" size="small" placeholder="请输入版本号"></el-input>
          </el-col>
          <!-- <el-col :span="6">
            <a>{{guja.name}}</a>
          </el-col>
          <el-col :span="6">
            <a>{{guja.datarq}}</a>
          </el-col> -->
        </el-form-item>
        <el-form-item label="固件二" prop="name" v-if="gujy == '2'" :label-width="formLabelWidth">
          <el-col :span="11">
            <el-upload action="#" :limit="1" :auto-upload="false" :on-change="handleChangeh">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-col>
          <el-col :span="11" style="margin-right:15px">
            <el-input clearable v-model="gujb.version" size="small" placeholder="请输入版本号"></el-input>
          </el-col>
          <!-- <el-col :span="6">
            <a>{{gujb.name}}</a>
          </el-col>
          <el-col :span="6">
            <a>{{gujb.datarq}}</a>
          </el-col> -->
        </el-form-item>
        <el-form-item label="固件三" prop="name" v-if="gujy == '3'" :label-width="formLabelWidth">
          <el-col :span="11">
            <el-upload action="#" :limit="1" :auto-upload="false" :on-change="handleChangej">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-col>
          <el-col :span="11" style="margin-right:15px">
            <el-input clearable v-model="gujc.version" size="small" placeholder="请输入版本号"></el-input>
          </el-col>
          <!-- <el-col :span="6">
            <a>{{gujc.name}}</a>
          </el-col>
          <el-col :span="6">
            <a>{{gujc.datarq}}</a>
          </el-col> -->
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import excel from '@/libs/excel'
import bcrypt from 'bcryptjs';
export default {
  data() {
    return {
      picUrl: process.env.VUE_APP_PIc_URL,
      selectedUser: null,
      alldelete: false,
      shownumber: false,
      dialogFormVisible: false,
      dialogFormVisiblr: false,
      formLabelWidth: '70px',
      title: '添加',
      startdate: '',
      enddate: '',
      fuserList: null,
      userList: [],
      // dataList: [],
      search: '',
      searchphone: '',
      checkAll: '',
      currentPage: 1,
      itemsPerPage: 16,
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      form: {
        networknum: '',
        equipmentnum: ''
      },
      rules: {
        namea: [
          { required: true, message: '请输入产品名称', trigger: 'blur' },
          { min: 5, max: 18, message: '长度在 5 到 18 个字符', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入型号', trigger: 'blur' },
          { min: 5, max: 18, message: '长度在 5 到 18 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 5, max: 18, message: '长度在 5 到 18 个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 11, max: 11, message: '请输入正确的手机号', trigger: 'blur' }
        ]
      },
      token: localStorage.getItem('token'),
      uploadUrl: process.env.VUE_APP_BASE_URL + '/upload/image',
      formdata: {
        name: '',
        namea: '',
        nameb: '',
        namec: '',
        named: '',
        namev: '',
        mobile: '',
        email: '',
        pic: '',
        gjfile: [],
        status: 'true'
      },
      guja: {
        version: '',
        date: '',
        url: '',
        name: ''
      },
      gujb: {
        version: '',
        date: '',
        url: '',
        name: ''
      },
      gujc: {
        version: '',
        date: '',
        url: '',
        name: ''
      },
      delid: '',//删除时的临时id
      rolelist: [],
      srcList: ['http://test.hi-wooya.com/headimg/upload_7802168047da2bcd564b947c76a525e9.png'],
      gujy: '',
      guje: '2',
      gujs: '3',
      current: 1,
      size: 10,
      percentageg: 0,
      percentageh: 0,
      percentagej: 0,
      percentagegshow: false,
      percentagehshow: false,
      percentagejshow: false,
    }
  },
  created() {
    this.$js.token();
    //sessionStorage.setItem('tabid', '8');
    sessionStorage.setItem('path', '/Admindata');
    sessionStorage.setItem('netpage', '1');
    this.selectuser()
    this.changeheight()
  },
  computed: {
    displayedBoxes() {
      const startIndex = this.currentPage * this.itemsPerPage - this.itemsPerPage
      const endIndex = startIndex + this.itemsPerPage
      //return this.fuserList.slice(startIndex, endIndex)
      return this.fuserList;
    },
    totalPages() {
      return Math.ceil(this.fuserList.length / this.itemsPerPage)
    },
    pages() {
      const pages = [1];
      for (let i = 2; i <= this.totalPages; i++) {
        pages.push(i);
      }
      return pages;
    },
    serviceurl() {
      return this.picUrl.split(":")[0] + ":" + this.picUrl.split(":")[1]
    }
  },
  mounted() {
    console.log(this.picUrl.split(":")[0] + ":" + this.picUrl.split(":")[1], 'dddddddddddddddddddddddd');
  },
  methods: {
    gujaedit(val) {
      this.dialogVisible = true;
      this.gujy = val;
    },
    editguje(val) {
      this.guje = val;
    },
    editgujs(val) {
      this.gujs = val;
    },
    goToPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    hqtpfd(val) {
      console.log(val);
      this.srcList.push(val);
    },
    handleRemoveg(file) {
      console.log(file);
    },
    handlePictureCardPreviewg(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownloadg(file) {
      console.log(file);
    },
    convertToBeijingTime(isoString) {
      const date = new Date(isoString);
      const beijingTime = date.toLocaleString('zh-CN', {
        timeZone: 'Asia/Shanghai',
      });
      return beijingTime;
    },
    async handleChangeg(file, fileList) {
      this.percentageg = 0
      this.percentagegshow = true
      this.guja.url = file.raw;
      this.guja.name = file.name;
      const interval = setInterval(() => {
        this.percentageg += Math.floor(Math.random() * 10) + 5
        if (this.percentageg >= 100) {
          this.percentageg = 100
          clearInterval(interval)
          setTimeout(() => {
            this.percentagegshow = false
          }, 500)
        }
      }, 300)

      // file.path = file.url;
      // let formData = new FormData();
      // formData.append('avatar', file.raw);
      // let res = await this.$apiFun.addproductpic(formData);
      // if (res.code === 200) {
      //   this.guja.date = this.convertToBeijingTime(res.file.lastModifiedDate);
      //   this.guja.url = res.file.path;
      //   this.guja.name = res.file.name;
      // }
    },
    async handleChangeh(file, fileList) {
      this.percentageh = 0
      this.percentagehshow = true
      this.gujb.url = file.raw;
      this.gujb.name = file.name;
      const interval = setInterval(() => {
        this.percentageh += Math.floor(Math.random() * 10) + 5
        if (this.percentageh >= 100) {
          this.percentageh = 100
          clearInterval(interval)
          setTimeout(() => {
            this.percentagehshow = false
          }, 500)
        }
      }, 300)
      // file.path = file.url;
      // let formData = new FormData();
      // formData.append('avatar', file.raw);
      // let res = await this.$apiFun.addproductpic(formData);
      // if (res.code === 200) {
      //   this.gujb.date = this.convertToBeijingTime(res.file.lastModifiedDate);
      //   this.gujb.url = res.file.path;
      //   this.gujb.name = res.file.name;
      // }
    },
    async handleChangej(file, fileList) {
      this.percentagej = 0
      this.percentagejshow = true
      this.gujc.url = file.raw;
      this.gujc.name = file.name;
      const interval = setInterval(() => {
        this.percentagej += Math.floor(Math.random() * 10) + 5
        if (this.percentagej >= 100) {
          this.percentagej = 100
          clearInterval(interval)
          setTimeout(() => {
            this.percentagejshow = false
          }, 500)
        }
      }, 300)
      // file.path = file.url;
      // let formData = new FormData();
      // formData.append('avatar', file.raw);
      // let res = await this.$apiFun.addproductpic(formData);
      // if (res.code === 200) {
      //   this.gujc.date = this.convertToBeijingTime(res.file.lastModifiedDate);
      //   this.gujc.url = res.file.path;
      //   this.gujc.name = res.file.name;
      // }
    },
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    async handleChange(file, fileList) {
      if (file.status !== 'ready') return // 阻止上传成功的触发
      this.dialogImageUrl = URL.createObjectURL(file.raw);
      this.formdata.pic = file.raw;
      // let formDatas = new FormData();
      // formDatas.append('avatar', file.raw);
      //console.log(file, fileList);
      // let res = await this.$apiFun.addproductpic(formDatas);
      // //console.log(res);
      // if (res.code === 200) {
      //   this.formdata.pic = res.file.path;
      //   this.dialogImageUrl = res.file.path;
      //   //console.log(res.file.path);
      // }
    },
    goToNextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    //添加管理员
    addadmin() {
      this.dialogFormVisible = true;
      this.title = '新增产品';
      this.formdata.name = '';
      this.formdata.namea = '';
      this.formdata.nameb = '';
      this.formdata.namec = '';
      this.formdata.named = '';
      this.formdata.mobile = '';
      this.formdata.pic = '';
      this.formdata.email = '';
      this.formdata.password = '';
      this.formdata.issuper = '';
      this.selectuser();
      this.gujy = '11';
      this.guje = '22';
      this.gujs = '33';
      this.dialogImageUrl = "";
      this.guja.version = '';
      this.guja.date = '';
      this.guja.url = '';
      this.guja.name = '';
      this.gujb.version = '';
      this.gujb.date = '';
      this.gujb.url = '';
      this.gujb.name = '';
      this.gujc.version = '';
      this.gujc.date = '';
      this.gujc.url = '';
      this.gujc.name = '';
    },
    // 获取页面大小
    changeheight() {
      if (document.documentElement.clientHeight <= 800 && document.documentElement.clientHeight > 750) {
        this.itemsPerPage = 12
      } else if (document.documentElement.clientHeight <= 750 && document.documentElement.clientHeight > 720) {
        this.itemsPerPage = 11
      } else if (document.documentElement.clientHeight < 720) {
        this.itemsPerPage = 7
      }
    },
    // 删除成员
    async userDelete(id) {
      // console.log(id);
      let res = await this.$apiFun.delproduct({ id })
      //alert(res)
      if (res.code == 200) {
        this.$message({
          message: res.msg,
          type: 'success'
        });
        this.delid = '';
        this.selectuser();
      }
    },
    // 展示删除框
    shownotice(item) {
      //   if (item.notice) {
      //     item.notice = !item.notice
      //   } else {
      //     this.fuserList.forEach(item => {
      //       item.notice = false
      //     })
      //     item.notice = !item.notice
      //   }
      this.delid = item;
    },
    //展示改变设备数量
    changenumber(i) {
      //   this.shownumber = !this.shownumber
      //   if (i) {
      //     this.selectedUser = i
      //     this.form.networknum = i.networknum
      //     this.form.equipmentnum = i.equipmentnum
      //   }
      this.dialogFormVisiblr = true;
      this.title = '编辑产品';
      this.formdata.name = i.adminProductModel;
      this.formdata.namea = i.adminProductName;
      this.formdata.nameb = i.instructions;
      if (i.functionalArea == '1') {
        this.formdata.namec = true;
      }
      if (i.functionalArea == '2') {
        this.formdata.named = true;
      }
      if (i.functionalArea == '3') {
        this.formdata.named = true;
        this.formdata.namec = true;
      }
      if (i.functionalArea == '4') {
        this.formdata.namev = true;
      }
      if (i.functionalArea == '5') {
        this.formdata.namec = true;
        this.formdata.namev = true;
      }
      if (i.functionalArea == '6') {
        this.formdata.named = true;
        this.formdata.namev = true;
      }
      if (i.functionalArea == '7') {
        this.formdata.namec = true;
        this.formdata.named = true;
        this.formdata.namev = true;
      }
      this.formdata.id = i.id;
      this.formdata.pic = i.adminProductPIC;
      this.dialogImageUrl = this.picUrl + i.adminProductPIC;
      this.formdata.password = '';
      //let bjgujsj = JSON.parse(i.adminProductFirmware);
      for (let j = 0; j < i.firmware.length; j++) {
        if (i.firmware[j].flag == 1) {
          this.guja.version = i.firmware[j].version;
          this.guja.name = '已存在固件';
          this.guja.date = i.firmware[j].date;
          this.guja.url = i.firmware[j].url;
        }
        if (i.firmware[j].flag == 2) {
          this.gujb.version = i.firmware[j].version;
          this.gujb.name = '已存在固件';
          this.gujb.date = i.firmware[j].date;
          this.gujb.url = i.firmware[j].url;
        }
        if (i.firmware[j].flag == 3) {
          this.gujc.version = i.firmware[j].version;
          this.gujc.name = '已存在固件';
          this.gujc.date = i.firmware[j].date;
          this.gujc.url = i.firmware[j].url;
        }
      }
      this.gujy = '1';
      this.guje = '2';
      this.gujs = '3';
    },
    //改变设备数量
    async enternumber() {
      let id = this.selectedUser.id
      let networknum = this.form.networknum
      let equipmentnum = this.form.equipmentnum
      let res = await this.$apiFun.changenumber({ id, networknum, equipmentnum })
      console.log(res);
      location.reload()
    },
    // 时间开始
    changestartdate() {
      this.fuserList = [];
      let start = this.startdate ? this.startdate.getTime() : 0;
      let end = this.enddate ? this.enddate.getTime() : Infinity;
      this.fuserList = this.userList.filter(item => {
        let itemDate = item.date
        return itemDate >= start && itemDate <= end;
      });
    },
    //批量删除
    deleteallshow() {
      const allFalse = this.fuserList.every(obj => obj.checked === false);
      if (allFalse) {
        alert('请选择需要删除的用户')
      } else {
        this.alldelete = true
      }
    },
    deleteallcancel() {
      this.alldelete = false
    },
    deleteallenter() {
      const startIndex = this.currentPage * this.itemsPerPage - this.itemsPerPage
      const endIndex = startIndex + this.itemsPerPage
      this.fuserList.slice(startIndex, endIndex).forEach(async item => {
        if (item.checked == true) {
          let id = item.nwid
          let res = await this.$apiFun.delproduct(id);
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: 'success'
            });
            this.selectuser();
          }
          //alert(res)
        }
      })
      this.alldelete = false;
      this.selectuser();
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.size = val;
      this.selectuser();
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.current = val;
      this.selectuser();
    },
    // 搜索功能
    async handleSearch() {
      // this.fuserList = [];
      // this.userList.map(item => {
      //   if (item.name == this.searchphone) {
      //     this.fuserList.push(item);
      //   } else if (this.searchphone == "") {
      //     this.selectuser();
      //   }
      // });
      //this.selectuser();
      let res = await this.$apiFun.selectproduct({ flag: this.searchphone });
      if (res == false) {
        console.log(res);
      } else {
        this.userList = res.data.records
        this.fuserList = res.data.total
      }
    },
    //验证方法
    async verificationbd(vala, valb, valc, vald, vale) {
      if (vala == '') {
        this.$message({
          message: '请添加图片',
          type: 'warning'
        });
        return false;
      } else {
        if (valb.length < 0 || valc.length < 0) {
          this.$message({
            message: '请输入内容长度在 5 到 18 个字符',
            type: 'warning'
          });
          return false;
        } else {
          if (valc == '') {
            this.$message({
              message: '请输入产品名称',
              type: 'warning'
            });
            return false;
          } else {
            if (valb == '') {
              this.$message({
                message: '请输入产品型号',
                type: 'warning'
              });
              return false;
            } else {
              if (this.title == '新增产品') {
                this.formdata.gjfile = [];
                let data = JSON.parse(sessionStorage.getItem('user'));
                this.formdata.username = data.name;
                this.formdata.parentid = data.parentid;
                this.formdata.gjfile.push(this.guja, this.gujb, this.gujc);
                this.formdata.gjfile = JSON.stringify(this.formdata.gjfile);
                let formDatas = new FormData();
                formDatas.append('img', this.formdata.pic);
                //formDatas.append('username', this.formdata);
                //formDatas.append('data', this.formdata);
                formDatas.append('name', this.formdata.namea);
                formDatas.append('model', this.formdata.name);
                formDatas.append('link', this.formdata.nameb);
                formDatas.append('ver1', this.guja.version);
                formDatas.append('ver2', this.gujb.version);
                formDatas.append('ver3', this.gujc.version);
                if (this.formdata.namec == true && this.formdata.named == true && this.formdata.namev == true) {
                  formDatas.append('function', 7);
                } else if (this.formdata.named == true && this.formdata.namev == true) {
                  formDatas.append('function', 6);
                } else if (this.formdata.namec == true && this.formdata.namev == true) {
                  formDatas.append('function', 5);
                } else if (this.formdata.namev == true) {
                  formDatas.append('function', 4);
                } else if (this.formdata.namec == true && this.formdata.named == true) {
                  formDatas.append('function', 3);
                } else if (this.formdata.named == true) {
                  formDatas.append('function', 2);
                } else if (this.formdata.namec == true) {
                  formDatas.append('function', 1);
                } else {
                  formDatas.append('function', 0);
                }
                //formDatas.append('sjzx', this.formdata.named);
                formDatas.append('firmware1', this.guja.url);
                if (this.guja.url != '') {
                  if (this.guja.version == '') {
                    this.$message({
                      message: '请输入版本号',
                      type: 'warning'
                    });
                    return false;
                  }
                }
                formDatas.append('firmware2', this.gujb.url);
                if (this.gujb.url != '') {
                  if (this.gujb.version == '') {
                    this.$message({
                      message: '请输入版本号',
                      type: 'warning'
                    });
                    return false;
                  }
                }
                formDatas.append('firmware3', this.gujc.url);
                if (this.gujc.url != '') {
                  if (this.gujc.version == '') {
                    this.$message({
                      message: '请输入版本号',
                      type: 'warning'
                    });
                    return false;
                  }
                }
                let res = await this.$apiFun.addproduct(formDatas);
                if (res.code == 200) {
                  this.$message({
                    message: res.msg,
                    type: 'success'
                  });
                  this.dialogFormVisible = false;
                  this.selectuser();
                  this.handleClose()
                } else {
                  this.$message({
                    message: res.msg,
                    type: 'warning'
                  });
                }
              } else {
                //const salt = await bcrypt.genSalt(10);
                //const hashedPassword = await bcrypt.hash(this.formdata.password, salt);
                //this.formdata.password = hashedPassword;
                //console.log("12.16");
                //console.log(this.formdata);
                let formDatas = new FormData();
                formDatas.append('img', this.formdata.pic);
                formDatas.append('id', this.formdata.id);
                //formDatas.append('username', this.formdata);
                //formDatas.append('data', this.formdata);
                formDatas.append('name', this.formdata.namea);
                formDatas.append('model', this.formdata.name);
                formDatas.append('link', this.formdata.nameb);
                formDatas.append('ver1', this.guja.version);
                formDatas.append('ver2', this.gujb.version);
                formDatas.append('ver3', this.gujc.version);
                if (this.formdata.namec == true && this.formdata.named == true && this.formdata.namev == true) {
                  formDatas.append('function', 7);
                } else if (this.formdata.named == true && this.formdata.namev == true) {
                  formDatas.append('function', 6);
                } else if (this.formdata.namec == true && this.formdata.namev == true) {
                  formDatas.append('function', 5);
                } else if (this.formdata.namev == true) {
                  formDatas.append('function', 4);
                } else if (this.formdata.namec == true && this.formdata.named == true) {
                  formDatas.append('function', 3);
                } else if (this.formdata.named == true) {
                  formDatas.append('function', 2);
                } else if (this.formdata.namec == true) {
                  formDatas.append('function', 1);
                } else {
                  formDatas.append('function', 0);
                }
                //formDatas.append('sjzx', this.formdata.named);
                formDatas.append('firmware1', this.guja.url);
                if (this.guja.url != '') {
                  if (this.guja.version == '') {
                    this.$message({
                      message: '请输入版本号',
                      type: 'warning'
                    });
                    return false;
                  }
                }
                formDatas.append('firmware2', this.gujb.url);
                if (this.gujb.url != '') {
                  if (this.gujb.version == '') {
                    this.$message({
                      message: '请输入版本号',
                      type: 'warning'
                    });
                    return false;
                  }
                }
                formDatas.append('firmware3', this.gujc.url);
                if (this.gujc.url != '') {
                  if (this.gujc.version == '') {
                    this.$message({
                      message: '请输入版本号',
                      type: 'warning'
                    });
                    return false;
                  }
                }
                //console.log(linshijs);
                let res = await this.$apiFun.editproduct(formDatas);
                if (res.code == 200) {
                  this.$message({
                    message: res.msg,
                    type: 'success'
                  });
                  this.dialogFormVisiblr = false;
                  this.selectuser();
                  this.handleClose1()
                } else {
                  this.$message({
                    message: res.msg,
                    type: 'warning'
                  });
                }
                //alert(res)
              }
              //console.log(res);
              //location.reload();
            }
          }
        }
      }
    },
    isValidEmail(email) {
      var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      return emailRegex.test(email);
    },
    //提交数据
    async submitData() {

      //this.formdata.id = data.id
      this.verificationbd(this.formdata.pic, this.formdata.name, this.formdata.namea);
      //let res = await this.$apiFun.addnet({ netname, userid, username, parentid,label,project });
    },
    handleClose() {
      this.dialogFormVisible = false
      this.dialogFormVisiblr = false
      this.$refs.dialogformdata?.resetFields();
      this.formdata.name = '';
      this.formdata.namea = '';
      this.formdata.nameb = '';
      this.formdata.namec = '';
      this.formdata.named = '';
      this.formdata.namev = '';
      this.formdata.mobile = '';
      this.formdata.pic = '';
      this.formdata.email = '';
      this.formdata.password = '';
      this.formdata.issuper = '';
    },
    handleClose1() {
      this.dialogFormVisiblr = false
      this.$refs.dialogformdata1?.resetFields();
      this.formdata.name = '';
      this.formdata.namea = '';
      this.formdata.nameb = '';
      this.formdata.namec = '';
      this.formdata.named = '';
      this.formdata.namev = '';
      this.formdata.mobile = '';
      this.formdata.pic = '';
      this.formdata.email = '';
      this.formdata.password = '';
      this.formdata.issuper = '';
    },
    // 时间戳转换
    time(date) {
      let timestamp = parseInt(date);
      let time = new Date(timestamp);
      // 获取年、月、日
      let year = time.getFullYear();
      let month = ("0" + (time.getMonth() + 1)).slice(-2); // 月份是从0开始的，所以需要加1
      let day = ("0" + time.getDate()).slice(-2);
      // 格式化日期
      let formattedDate = year + "-" + month + "-" + day;
      return formattedDate
    },
    // 全选
    checkall() {
      this.fuserList.forEach(item => item.checked = this.checkAll)
    },
    //导出操作
    exportExcel() {
      let List = []
      this.fuserList.forEach(item => {
        if (item.checked == true) {
          List.push(item)
        }
      })
      if (List.length > 0) {
        const params = {
          title: ['账号', '电话', '邮箱', '注册日期', '网络数量', '设备数量'],
          key: ['name', 'mobile', 'email', 'date', 'networknum', 'equipmentnum'],
          data: List, // 数据源
          autoWidth: true, //autoWidth等于true，那么列的宽度会适应那一列最长的值
          filename: '客户数据'
        }
        excel.exportArrayToExcel(params)
      } else {
        alert('请勾选需要导出的网络')
      }
    },
    //查询用户信息
    async selectuser() {
      let Memberslen = 0
      let networkslen = 0
      let id = JSON.parse(sessionStorage.getItem('user')).id
      let issuper = JSON.parse(sessionStorage.getItem('user')).issuper
      //let res = await this.$apiFun.selectadmin({ id, issuper });
      let res = await this.$apiFun.selectproduct({ id, current: this.current, size: this.size, flag: this.searchphone });
      if (res == false) {
        console.log(res);
      } else {
        this.userList = res.data.records
        this.fuserList = res.data.total
      }
      //this.rolelist = await this.$apiFun.selectrole({ id });
    },
    // 修改操作
    updata() {
      alert('修改还没做')
    },
    // 自定义上传模式 el-upload
    customUpload() {
      // console.log('fffff');
    }
  }
}
</script>

<style scoped>
.content-box {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding: 0 1.1%;
  background-color: white;
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
}

.tab {
  font-size: 12px;
  padding-top: 10px;
  height: 38.8px;
  line-height: 38.8px;
}

.title-box {
  margin: 20px 0px 10px;
  height: 30px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ebeef5;
}

.title {
  font-size: 14px;
  font-weight: 700;
}

.btn-box {
  margin: -15px 0px 0px 0px;
  display: flex;
}

.addbox {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  height: 300px;
  z-index: 999;
  background-color: white;
}

.addtitle {
  padding: 25px 0px 0px 15px;
  font-size: 14px;
  font-weight: bold;
}

.addtable {
  margin-top: 40px;
  padding: 0px 80px;
}

.addbtn {
  height: 30px;
  line-height: 30px;
  background: #fafafa;
  padding: 0px 25px;
  font-size: 14px;
  border: 1px solid #dcdcdc;
  margin-left: 10px;
  cursor: pointer;
}

.notice {
  color: #333333;
  z-index: 999;
}

.overlay {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  /* 半透明黑色背景 */
  z-index: 999;
  /* 确保在上层 */
}

.deleteallbox {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  background-color: white !important;
}

/* .userkbtn:hover {
  color: #70c31d;
  cursor: pointer;
} */

.exportimg {
  width: 14px;
  height: 14px;
  margin-right: 10px;
}

.select-box {
  display: flex;
}

.select {
  margin: 0px 10px 20px 0px;
}

.search {
  margin: 0px 10px 20px 0px;
  line-height: 32px;
  padding: 0 16px;
  background-color: #1677ff;
  color: white;
  cursor: pointer;
  font-size: 12px;
}

.networkListtitle {
  min-width: 1630px;
  font-size: 12px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  padding: 0 8px;
  font-weight: bold;
  background-color: #fafafb;
  border-top: 1px solid #e7e9f1;
  border-bottom: 1px solid #e7e9f1;
}

.inputcheck {
  display: flex;
}

.username {
  width: 440px;
  line-height: 30px;
}

.select-box:deep(.el-input__inner) {
  width: 151px;
  height: 32px;
}

.select-box:deep(.el-date-editor.el-input, .el-date-editor.el-input__inner) {
  width: 150px;
}

.select-box:deep(.el-input__icon) {
  line-height: 32px;
}

.select:deep(.el-input__inner:focus) {
  border-color: #012f55;
}

.select:deep(.el-input.is-focus .el-input__inner) {
  border-color: #012f55;
}

.zdyxzcpzk:deep(.el-dialog__header) {
  padding: 20px 20px 0px;
}

.zdyxzcpzk:deep(.el-dialog__body) {
  padding: 5px 20px;
}

.zdyxzcpzk:deep(.el-dialog) {
  margin-top: 5vh !important;
}

.zdyxzcpzk:deep(.el-form-item) {
  margin-bottom: 10px;
}

.zdyxzcpzk:deep(.el-upload-list) {
  display: none;
}

.zdycpt:deep(.el-form-item__label) {
  float: unset !important;
}

.zdycpt:deep(.el-form-item__content) {
  border: 1px solid #ddd;
  background: #fbfbfb;
  padding: 20px;
  font-size: 35px;
  color: #1677ff;
}

.avatar-uploader {
  width: 100px;
  height: 100px;
  border: 1px dotted #cfcccc;
  text-align: center;
}

.zdybkys {
  margin-bottom: 0px !important;
}

.zdybkys:deep(.el-form-item__label) {
  float: unset !important;
}

.zdybkys:deep(.el-form-item__content) {
  border: 1px solid #ddd;
  background: #fbfbfb;
  padding: 10px 30px;
}

.btn {
  display: flex;
  align-items: center;
  padding: 0px 16px;
  height: 32px;
  line-height: 32px;
  margin: 0px 10px 0px 0px;
  border: 1px solid #e7e9f1;
  cursor: pointer;
  font-size: 12px;
  color: #fff;
}

.addbtn {
  height: 30px;
  line-height: 30px;
  background: #fafafa;
  padding: 0px 25px;
  font-size: 14px;
  border: 1px solid #dcdcdc;
  margin-left: 10px;
  cursor: pointer;
}

.deleteallbox {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* width: 210px; */
  /* height: 100px; */
  z-index: 999;
  background-color: white !important;
}

.userList {
  min-width: 1630px;
  display: flex;
  border-bottom: 1px solid #ebeef5;
  padding: 8px;
  font-size: 12px;
}

.userList:hover {
  background: #fafafb;
}

.usermobile {
  width: 12.3%;
  flex-shrink: 0;
}

.userfirm {
  width: 260px;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 30px;
  flex-shrink: 0;
}

.useremail {
  width: 264px;
  line-height: 30px;
  flex-shrink: 0;
}

.userdate {
  width: 580px;
  line-height: 30px;
  flex-shrink: 0;
}

.networknum {
  width: 19.22%;
  flex-shrink: 0;
}

.equipmentnum {
  width: 9.22%;
  flex-shrink: 0;
}

.networkoperate {
  position: relative;
  width: 75px;
  line-height: 30px;
  display: flex;
  /* justify-content: space-between; */
}

.userkbtn {
  color: #1677ff;
  border: none;
  cursor: pointer;
  height: 100%;
  margin-right: 6px;

  &:last-child {
    margin-right: 0;
  }
}

.inputcheck:deep(.el-checkbox__inner) {
  background: #edf2fc;
  border-color: #dcdfe6;
}

.inputcheck:deep(.el-checkbox__inner) {
  background: #edf2fc;
  border-color: #dcdfe6;
}

.inputcheck:deep(.el-checkbox__input.is-focus .el-checkbox__inner) {
  border-color: #012f55;
}

.inputcheck:deep(.el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  background: #012f55;
  border-color: #012f55;
}

.select:deep(.el-input__inner) {
  line-height: 32px;
}

.select:deep(.el-input__inner:hover) {
  border-color: #012f55;
}

.notice:deep(.el-input__inner:focus) {
  border-color: #012f55;
}

.notice:deep(.el-input.is-focus .el-input__inner) {
  border-color: #012f55;
}

.titlebox {
  padding: 8px 0px;
  background-color: #fafafb;
}

.el-progress {
  width: 160px;
}

:deep(.el-progress) .el-progress__text {
  font-size: 12px !important;
}

@media screen and (min-width: 1680px) {
  .titlebox {
    padding: 8px 0px;
    border: none;
  }

  .networkListtitle {
    background-color: #fafafb;
    border-top: 1px solid #e7e9f1;
    border-bottom: 1px solid #e7e9f1;
  }
}
</style>